<!-- 饮用水源地详情 -->
<template>
  <div class="dialog-monitor">
    <div class="header">
      <div class="title">{{ data.dmmc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <h5>基本信息</h5>
          <div class="descriptions-item">
            <span class="key">供水类型:</span>
            <span class="value">{{ data.zdlx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">水源地类型:</span>
            <span class="value">{{ data.yysydlx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在镇街:</span>
            <span class="value">{{ data.szzj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">设计供水规模:</span>
            <span class="value">{{ data.zkr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">有效蓄水水量:</span>
            <span class="value">{{ data.fhkr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">是否划分保护区:</span>
            <span v-show="data.bhq" class="value">是</span>
            <span v-show="!data.bhq" class="value">否</span>
            <!-- <span class="value">
              <n-radio-group v-model:value="data.bhq" name="radiogroup">
                <n-space>
                  <n-radio :value="true">是</n-radio>
                  <n-radio :value="false">否</n-radio>
                </n-space>
              </n-radio-group>
            </span> -->
          </div>
        </div>
        <div class="descriptions-group">
          <h5>水质监测</h5>
          <div class="descriptions-item">
            <span class="key">监测类型:</span>
            <span class="value">{{ data.monitorType || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">监测方式:</span>
            <span class="value">{{ data.monitorFunc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">目标水质:</span>
            <span class="value">{{ data.targetSz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">当前水质：</span>
            <span class="value">{{ data.nowSz || '-' }}</span>
          </div>
          <div class="descriptions-item2">
            <span class="key">主要污染物：</span>
            <span class="value">{{ data.skbhfwmj || '-' }}</span>
          </div>
        </div>
        <div>
          <span
            v-for="(item, index) in props.data.data"
            v-show="item.name"
            :key="index"
            class="code-btn"
            :class="item.name == active ? 'active' : ''"
            @click="changeCode(item)"
            >{{ item.name }}</span
          >
        </div>
        <div v-if="data.data" class="descriptions-group">
          <div ref="chart" class="chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
import { Api, DmYzDatumLineQuery } from '@/api/publicApi'

const api = new Api()
const props = defineProps({
  // eslint-disable-next-line no-undef
  data: Object,
})
// eslint-disable-next-line no-undef
// if (!props.data.value && props.data.value !== 0) {
//   // eslint-disable-next-line vue/no-mutating-props
//   props.data.value = 1
// }
const { data } = toRefs(props)
const { proxy } = getCurrentInstance()
const chart = ref()
let myChart = {}
const testY = []
const testX = []
const active = ref('')
// if (myChart) {
//   myChart.clear()
// }

// for(let i=0;i<props.data..data.length;i++) {}

const max = null
const option = {
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'item',
  },
  grid: {
    show: true,
    top: 40,
    left: 40,
    right: 45,
    bottom: 60,
    borderWidth: '0',
  },
  yAxis: {
    name: 'mg/L',
    nameTextStyle: {
      fontSize: 14,
      color: '#ffffff',
    },
    show: true,
    type: 'value',
    min: 0,
    max,
    splitLine: {
      show: true,
      lineStyle: {
        width: 2,
        dashOffset: 10,
        type: 'dashed',
        color: 'rgba(230, 247, 255, 0.2)',
      },
    },
    axisLabel: {
      formatter: '{value}',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  xAxis: {
    data: testX,
    boundaryGap: false,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#ffffff',
      },
    },

    axisLabel: {
      type: 'category',
      formatter: '{value}',
      rotate: '45',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  series: [
    {
      name: '监测值(mg/L)',
      type: 'line',
      color: '#09CEA5',
      smooth: false, // 关键点，为true是不支持虚线，实线就用true
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
            type: 'dotted', // 'dotted'虚线 'solid'实线
          },
        },
      },
      // markLine: {
      //   symbol: 'none',
      //   data: [
      //     {
      //       yAxis: 0.6,
      //       valueIndex: 1,
      //       // coord:['60','7'],
      //       lineStyle: {
      //         normal: {
      //           color: '#fd0',
      //           type: 'dashed',
      //         },
      //       },
      //       label: {
      //         normal: {
      //           // show: false,
      //           color: '#fd0',
      //           formatter: '标准值'
      //         },
      //       },
      //     },
      //   ],
      // },
      lineWidth: 2,
      symbol: '',
      symbolSize: 10,
      data: testY,
    },
  ],
}

// 获取图表数据
const getChartData = (data) => {
  active.value = data.name
  option.xAxis.data = data.xaxis
  option.series[0].data = data.trend
  const params: DmYzDatumLineQuery = {
    code: data.code,
    bzszlb: props.data.targetSzn,
    stlx: props.data.stlx,
  }
  api.screen.getDmYzDatumLineUsingPost(params).then((res) => {
    if (res.code === 200) {
      let flag
      for (let i = 0; i < data.trend.length; i++) {
        if (res.data && res.data.datumLine && data.trend[i] > res.data.datumLine) {
          flag = true
          break
        }
      }
      if (!flag && res.data && res.data.datumLine) {
        option.yAxis.max = res.data.datumLine
      }
      if (res.data && res.data.datumLine) {
        option.series[0].markLine = {
          symbol: 'none',
          data: [
            {
              yAxis: res.data.datumLine,
              valueIndex: 1,
              // coord:['60','7'],
              lineStyle: {
                normal: {
                  color: '#fd0',
                  type: 'dashed',
                },
              },
              label: {
                normal: {
                  // show: false,
                  color: '#fd0',
                  formatter: '标准值',
                },
              },
            },
          ],
        }
      } else {
        option.series[0].markLine = null
      }
      myChart.setOption(option)
    }
  })
}

const changeCode = (data) => {
  getChartData(data)
}

getChartData(props.data.data[0])

// nextTick(() => {
//   myChart.setOption(option)
// })
onMounted(() => {
  console.log(chart.value)
  myChart = proxy.$echarts.init(chart.value)
})
</script>

<style lang="scss" scoped>
.dialog-monitor {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          display: flex;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
        .descriptions-item2 {
          width: 100%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
        .chart {
          width: 100%;
          height: 200px;
        }
      }
    }
  }
  .code-btn {
    white-space: nowrap;
    padding: 4px 0.6rem;
    height: 2.65rem;
    line-height: 2.65rem;
    margin-right: 0.9rem;
    background-color: transparent;
    border: 0.025rem solid transparent;
    color: #8ec0ce;
    cursor: pointer;
  }
  .code-btn.active {
    background: #00acff !important;
    color: #ffffff !important;
  }
}
</style>
